export const salt = () => {
  // @Returns a 9-character string of random numbers and letters
  // to provide a unique key for repeating elements in a loop
  // eg: o3qfpgfr5
  return Math.random()
    .toString(36)
    .substr(2, 9);
};

export const getSlug = (url, trailingSlash = false) => {
  // @Returns the last segment of the given `url`
  const offset = trailingSlash ? -2 : -1;
  return url.split("/").slice(offset)[0];
};

export const scrollToBottom = el => {
  el.current.scrollTop = el.current.scrollHeight;
};

export const lockScroll = () => {
  // document.body.style.top = `-${window.scrollY}px`;
  // document.body.style.position = "fixed";
};

export const unlockScroll = () => {
  const scrollY = document.body.style.top;
  document.body.style.position = "";
  document.body.style.top = "";
  const html = document.querySelector("html");
  html.style.scrollBehavior = "auto";
  window.scrollTo({ top: parseInt(scrollY || "0") * -1 });
  html.style.scrollBehavior = "smooth";
};

export const getCurrentLanguage = () => {
  return ('lxl_chatbot_lang' in window ) 
    ? window.lxl_chatbot_lang.dialogFlowLang
    : document.documentElement.lang.replace(/_/gi, '-') || 'en-GB';
}

export const languageContent = () => {
  const languageKey = getCurrentLanguage().toLowerCase();
  let language = {};
  try {
    language = require(`../languages/${languageKey}`).default;
  } catch (e) {
    if (e instanceof Error && e.code === "MODULE_NOT_FOUND") {
      language = require('../languages/en-gb').default;
    } else {
      throw e;
    }
  }
  return language;
};
